// extracted by mini-css-extract-plugin
export default {"main_container":"MobileInput_main_container__pXTed"};